/** Module icons named by the descriptors (`ui.icon`), registered with the shell (registerIcons). */
import React from "react";
import {
  AlertOutlined, ApartmentOutlined, AuditOutlined, BankOutlined, CheckCircleOutlined, DatabaseOutlined,
  EnvironmentOutlined, FileProtectOutlined, IdcardOutlined, LaptopOutlined, NodeIndexOutlined, PartitionOutlined,
  ReadOutlined, ReconciliationOutlined, SafetyCertificateOutlined, TagsOutlined, TeamOutlined, WarningOutlined,
} from "@ant-design/icons";

export const MODULE_ICONS: Record<string, React.ReactNode> = {
  AlertOutlined: <AlertOutlined />, ApartmentOutlined: <ApartmentOutlined />, AuditOutlined: <AuditOutlined />,
  BankOutlined: <BankOutlined />, CheckCircleOutlined: <CheckCircleOutlined />, DatabaseOutlined: <DatabaseOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />, FileProtectOutlined: <FileProtectOutlined />, IdcardOutlined: <IdcardOutlined />,
  LaptopOutlined: <LaptopOutlined />, NodeIndexOutlined: <NodeIndexOutlined />, PartitionOutlined: <PartitionOutlined />,
  ReadOutlined: <ReadOutlined />, ReconciliationOutlined: <ReconciliationOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />, TagsOutlined: <TagsOutlined />, TeamOutlined: <TeamOutlined />,
  WarningOutlined: <WarningOutlined />,
};
